/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateUpdateQuestionDto } from './CreateUpdateQuestionDto';
import {
    CreateUpdateQuestionDtoFromJSON,
    CreateUpdateQuestionDtoFromJSONTyped,
    CreateUpdateQuestionDtoToJSON,
} from './CreateUpdateQuestionDto';

/**
 * 
 * @export
 * @interface UpdateQuestionsDto
 */
export interface UpdateQuestionsDto {
    /**
     * 
     * @type {Array<CreateUpdateQuestionDto>}
     * @memberof UpdateQuestionsDto
     */
    questions: Array<CreateUpdateQuestionDto>;
}

/**
 * Check if a given object implements the UpdateQuestionsDto interface.
 */
export function instanceOfUpdateQuestionsDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "questions" in value;

    return isInstance;
}

export function UpdateQuestionsDtoFromJSON(json: any): UpdateQuestionsDto {
    return UpdateQuestionsDtoFromJSONTyped(json, false);
}

export function UpdateQuestionsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateQuestionsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'questions': ((json['questions'] as Array<any>).map(CreateUpdateQuestionDtoFromJSON)),
    };
}

export function UpdateQuestionsDtoToJSON(value?: UpdateQuestionsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'questions': ((value.questions as Array<any>).map(CreateUpdateQuestionDtoToJSON)),
    };
}

